import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  errorTitle: {
    id: "funding-application: email verification failure title",
    defaultMessage: "Sorry, an error occurred during email verification.",
  },
});
